export const BOLETO_DELINQUENCY_STATUS_ENUM = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
} as const;

export type BOLETO_DELINQUENCY_STATUS_ENUM =
  (typeof BOLETO_DELINQUENCY_STATUS_ENUM)[keyof typeof BOLETO_DELINQUENCY_STATUS_ENUM];
